module.exports = __webpack_public_path__ + "static/media/pegamento.6aef752c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/pegamento.webp
// module id = 479
// module chunks = 0